__webpack_require__.p = "/Deep_Prajapati_Portfolio/";